import Vue from 'vue'
import { TRACKING_ID_COOKIE_NAME, ORIGIN_PLATFORM_COOKIE_NAME, DEFAULT_PLATFORM } from '@/constants'
import { getCookieByName } from '@/utils/cookie'

export function trackEvent (eventName, optionalEventData = undefined) {
  if (Vue.gtm.enabled()) {
    const tid = getCookieByName(TRACKING_ID_COOKIE_NAME) || null
    const originPlatform = getCookieByName(ORIGIN_PLATFORM_COOKIE_NAME) || null

    window.dataLayer?.push({
      event: eventName,
      user_id: tid,
      platform: DEFAULT_PLATFORM,
      origin_platform: originPlatform,
      ...optionalEventData
    })
  }
}
